const AIDesk = {
  "结束会话": "結束會話",
  "转人工服务": "人工服務",
  "跳转": "跳轉",
  "立即填写": "立即填寫",
  "已提交": "已提交",
  "提交": "提交",
  "查看内容": "查看內容",
  "请填写必填项": "請填寫必填項",
  "请输入内容": "請輸入內容",
  "如果满意请给好评哦～": "如果滿意請給好評哦～",
  "请对本次服务进行评价": "請對本次服務進行評價",
  "提交评价": "提交評價",
  "服务评价": "服務評價",
  "并发限制": "目前諮詢人數較多，請稍後再試",
  "分支选项异常": "內容異常，請檢查任務流配置",
  "满意": "滿意",
  "不满意": "不滿意",
  "感谢您的反馈，我们会持续优化改进": "感謝您的反饋，我們會持續優化改進",
  "您遇到了哪方面的问题": "您遇到了哪方面的問題",
  "其他反馈内容": "其他反饋內容",
  "取消": "取消",
  "答非所问": "答非所問",
  "未匹配相关内容": "未匹配相關內容",
  "信息错误": "信息錯誤",
  "上下文理解错误": "上下文理解錯誤",
  "格式不规范": "格式不規範",
  "内容不完整": "內容不完整",
  "file 大小超过 100MB，无法发送": "檔案大小超過100MB，無法傳送",
  "image 大小超过 20MB，无法发送": "圖片大小超過20MB，無法傳送",
  "video 大小超过 100MB，无法发送": "影片大小超過100MB，無法傳送",
  "提交成功": "提交成功",
  "userID 只能包含可打印 ASCII 字符": "userID 只能包含可打印 ASCII 字元",
  "userID 不能包含'administrator'": "userID 不能包含'administrator'",
  "userID 长度不能超过45字节": "userID 長度不能超過45位元組",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "我們想知道你對此回答不滿意的原因，你認為更好的答案是什麼?",
  "排队等待中": "排隊等待中",
  "排队等待话术": "抱歉，目前所有人工客服已達到服務上限，請耐心等待，我們很快就來接待您，感謝您的理解。",
  "当前前方排队人数": "目前前方排隊人數",
  "结束排队": "結束排隊",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "評價提交超過3分鐘，無法更改。感謝您的反饋！",
  "不能发送空白消息": "不能發送空白訊息",
  "确认转人工": "確認轉人工",
}
export default AIDesk;
